import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const withPublicRouteCheck = (Component) => (props) => {
  const { isAuthorized } = useSelector((store) => store.auth);

  if (isAuthorized) {
    return <Navigate to="/" />;
  }

  return <Component {...props} />;
};

export default withPublicRouteCheck;
